// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._5saOGoqaqZpkYn_5icC {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.IEI8LVBd8zqINweD1LQr {
  display: block;
  margin-bottom: 1rem;
  white-space: nowrap;
}

.wY7RpKmRU7PpyQR1b7lK {
  display: flex;
  align-items: center;
  padding: 0 var(--form-input-prefix-padding);
  font-weight: bold;
  font-size: 1rem;
  line-height: 1.875rem;
  height: 100%;
  background-color: var(--grey-200);
  border-top-left-radius: var(--form-input-border-radius);
  border-bottom-left-radius: var(--form-input-border-radius);
}

.DIa94qkaUorojjxBoaW8 {
  width: 100%
}

.DIa94qkaUorojjxBoaW8 .itFBSr501CJ1K6xENHIX {
    position: relative;
  }

.DIa94qkaUorojjxBoaW8 .VuK4CecepGSeSwTkC1CQ {
    --horizontal-padding: 1.5rem;
    --height: 4rem;

    padding-left: var(--horizontal-padding);
    padding-right: var(--horizontal-padding);
    background-color: var(--white);
    border: 0.0625rem solid var(--grey-200);
    color: var(--midnight-purple);
    caret-color: var(--midnight-purple);
    box-sizing: border-box;
    border-radius: var(--form-input-border-radius);
    width: 100%;
    height: var(--height);
    font-style: normal;
    font-weight: normal;
    font-size: 1.125rem;
    line-height: 1.5rem;
    appearance: none;
    outline: none
  }

.DIa94qkaUorojjxBoaW8 .VuK4CecepGSeSwTkC1CQ.xLrQziaN3K5nCv1XHpGg {
      height: calc(var(--height) - 0.125rem);
      margin-top: 0;
      border: none;
      border-top-right-radius: var(--form-input-border-radius);
      border-bottom-right-radius: var(--form-input-border-radius);
      flex-grow: 1;
      padding-left: var(--form-input-prefix-padding)
    }

.DIa94qkaUorojjxBoaW8 .VuK4CecepGSeSwTkC1CQ.xLrQziaN3K5nCv1XHpGg:focus {
        padding-left: var(--form-input-prefix-padding);
      }

.DIa94qkaUorojjxBoaW8 .VuK4CecepGSeSwTkC1CQ[type=number] {
    /* remove arrows in Firefox */
    -moz-appearance: textfield

    /* remove arrows in Chrome, Safari, Edge, Opera */
  }

.DIa94qkaUorojjxBoaW8 .VuK4CecepGSeSwTkC1CQ[type=number]::-webkit-inner-spin-button,
    .DIa94qkaUorojjxBoaW8 .VuK4CecepGSeSwTkC1CQ[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
      opacity: 1;
    }

.DIa94qkaUorojjxBoaW8 .VuK4CecepGSeSwTkC1CQ:focus {
    outline: none;
    padding-left: calc(var(--horizontal-padding) - 0.0625rem);
    padding-right: calc(var(--horizontal-padding) - 0.0625rem);
    border-width: 0.125rem;
    border-color: var(--primary-border-color);
  }

.DIa94qkaUorojjxBoaW8 .VuK4CecepGSeSwTkC1CQ::placeholder {
    color: var(--grey-300);
  }

.DIa94qkaUorojjxBoaW8 .VuK4CecepGSeSwTkC1CQ:hover {
    border-color: var(--primary-border-color);
  }

.DIa94qkaUorojjxBoaW8 .ma2xUY1yfXNY3BL2LDYZ {
    padding-right: calc(var(--horizontal-padding) * 2);
  }

.DIa94qkaUorojjxBoaW8 .ma2xUY1yfXNY3BL2LDYZ:focus {
    padding-left: calc(var(--horizontal-padding) - 0.0625rem);
    padding-right: calc(var(--horizontal-padding) * 2 - 0.0625rem);
  }

.DIa94qkaUorojjxBoaW8 .htmpsd5qxrh9LvOwBvFw {
    padding-left: calc(var(--horizontal-padding) * 2);
  }

.DIa94qkaUorojjxBoaW8 .htmpsd5qxrh9LvOwBvFw:focus {
    padding-left: calc(var(--horizontal-padding) * 2 - 0.0625rem);
  }

.DIa94qkaUorojjxBoaW8 .B8rsTK4RqGn1suRBwybA {
    --vertical-padding: 1.25rem;

    height: 10rem;
    resize: vertical;
    padding-top: var(--vertical-padding);
    padding-bottom: var(--vertical-padding);
  }

.DIa94qkaUorojjxBoaW8 .B8rsTK4RqGn1suRBwybA:focus {
    padding-top: calc(var(--vertical-padding) - 0.0625rem);
    padding-bottom: calc(var(--vertical-padding) - 0.0625rem);
  }

.DIa94qkaUorojjxBoaW8 {

  /* stylelint-disable-next-line no-descending-specificity */
}

.DIa94qkaUorojjxBoaW8 .B8rsTK4RqGn1suRBwybA::-webkit-resizer {
    display: none;
  }

.DIa94qkaUorojjxBoaW8 {

  /* stylelint-disable-next-line no-descending-specificity */
}

.DIa94qkaUorojjxBoaW8 .B8rsTK4RqGn1suRBwybA::-webkit-scrollbar {
    display: none;
  }

.DIa94qkaUorojjxBoaW8 ._M5zfzDlwNx3sjNdOI9v {
    padding-bottom: 2.1875rem;
  }

.DIa94qkaUorojjxBoaW8 ._M5zfzDlwNx3sjNdOI9v:focus {
    padding-bottom: 2.125rem;
  }

.DIa94qkaUorojjxBoaW8 .vaeZOGUjbIQLFfX4JDFg {
    cursor: pointer;
    position: absolute;
    font-size: 1.125rem;
    top: 1.3125rem;
    left: 1.375rem;
  }

.DIa94qkaUorojjxBoaW8 .NXATkVeiojKovBcZqxFV {
    cursor: pointer;
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
  }

.DIa94qkaUorojjxBoaW8 .DcO1wOEewzseWVtETbh0 {
    color: var(--grey-300);
    position: absolute;
    bottom: 1rem;
    right: 1.25rem;
  }

.DIa94qkaUorojjxBoaW8 .AxEvxUN6MOLX9F7Z_cUp {
    display: flex;
    align-items: center;
    padding-top: 0.75rem
  }

.DIa94qkaUorojjxBoaW8 .AxEvxUN6MOLX9F7Z_cUp .hsWV54zL5Y7qSYDYnQyn {
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      line-height: 1.25rem;
      font-size: 0.875rem;
      color: var(--grey-400);

      /* 8 + 8 + 16 (margins and the icon) */
      max-width: calc(100% - 2rem);
    }

.DIa94qkaUorojjxBoaW8.Z9HVzWhzLwR46SEgCaSZ .VuK4CecepGSeSwTkC1CQ {
      padding-left: calc(var(--horizontal-padding) - 0.125rem);
      padding-right: calc(var(--horizontal-padding) - 0.125rem);
      border-width: 0.125rem;
      border-color: var(--error-red)
    }

.DIa94qkaUorojjxBoaW8.Z9HVzWhzLwR46SEgCaSZ .VuK4CecepGSeSwTkC1CQ.xLrQziaN3K5nCv1XHpGg {
        height: calc(var(--height) - 0.25rem);
        padding-left: var(--form-input-prefix-padding);
      }

.DIa94qkaUorojjxBoaW8.Z9HVzWhzLwR46SEgCaSZ .VuK4CecepGSeSwTkC1CQ:focus {
      border-color: var(--error-red);
    }

.DIa94qkaUorojjxBoaW8.Z9HVzWhzLwR46SEgCaSZ .VuK4CecepGSeSwTkC1CQ:hover {
      border-color: var(--error-red);
    }

.DIa94qkaUorojjxBoaW8.Z9HVzWhzLwR46SEgCaSZ .ma2xUY1yfXNY3BL2LDYZ {
      padding-right: calc(var(--horizontal-padding) * 2 - 0.0625rem);
    }

.DIa94qkaUorojjxBoaW8.Z9HVzWhzLwR46SEgCaSZ .htmpsd5qxrh9LvOwBvFw {
      padding-left: calc(var(--horizontal-padding) * 2 - 0.0625rem);
    }

.DIa94qkaUorojjxBoaW8.Z9HVzWhzLwR46SEgCaSZ .B8rsTK4RqGn1suRBwybA {
      padding-top: calc(var(--vertical-padding) - 0.0625rem);
      padding-bottom: calc(var(--vertical-padding) - 0.0625rem);
    }

.DIa94qkaUorojjxBoaW8.Z9HVzWhzLwR46SEgCaSZ .AxEvxUN6MOLX9F7Z_cUp .hsWV54zL5Y7qSYDYnQyn {
        color: var(--error-red);
      }

.DIa94qkaUorojjxBoaW8.bxaPPasZ_E4iBMbNH6vL {
    opacity: 0.5

    /* stylelint-disable-next-line no-descending-specificity */
  }

.DIa94qkaUorojjxBoaW8.bxaPPasZ_E4iBMbNH6vL .VuK4CecepGSeSwTkC1CQ {
      border-color: var(--grey-200);
      color: var(--grey-300);
    }

.DIa94qkaUorojjxBoaW8.bxaPPasZ_E4iBMbNH6vL .VuK4CecepGSeSwTkC1CQ:focus {
      padding-left: var(--horizontal-padding);
      padding-right: var(--horizontal-padding);
      border-width: 0.0625rem;
    }

.DIa94qkaUorojjxBoaW8.bxaPPasZ_E4iBMbNH6vL .VuK4CecepGSeSwTkC1CQ:hover {
      border-color: var(--grey-200);
    }

.DIa94qkaUorojjxBoaW8.bxaPPasZ_E4iBMbNH6vL .B8rsTK4RqGn1suRBwybA {
      resize: none;
    }

.DIa94qkaUorojjxBoaW8 .l8o3DL_utNNkXx7ZEOD1 {
    display: flex;
    padding-left: 0;
    padding-right: 0
  }

.DIa94qkaUorojjxBoaW8 .l8o3DL_utNNkXx7ZEOD1.VuK4CecepGSeSwTkC1CQ {
      padding: 0;
    }

.wEpvn100M9655bRc088q {
  white-space: unset;
  -webkit-hyphens: auto;
          hyphens: auto;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/Input/Input.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;EACjB,eAAe;EACf,qBAAiB;EACjB,YAAY;EACZ,iCAAiC;EACjC,uDAAuD;EACvD,0DAA0D;AAC5D;;AAEA;EACE;AAyOF;;AAvOE;IACE,kBAAkB;EACpB;;AAEA;IACE,4BAA0B;IAC1B,cAAc;;IAEd,uCAAuC;IACvC,wCAAwC;IACxC,8BAA8B;IAC9B,uCAAiC;IACjC,6BAA6B;IAC7B,mCAAmC;IACnC,sBAAsB;IACtB,8CAA8C;IAC9C,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAe;IACf,mBAAiB;IACjB,gBAAgB;IAChB;EAeF;;AAbE;MACE,sCAAiC;MACjC,aAAa;MACb,YAAY;MACZ,wDAAwD;MACxD,2DAA2D;MAC3D,YAAY;MACZ;IAKF;;AAHE;QACE,8CAA8C;MAChD;;AAIJ;IACE,6BAA6B;IAC7B,yBAA0B;;IAE1B,iDAAiD;EAOnD;;AANE;;MAEE,wBAAwB;MACxB,SAAS;MACT,UAAU;IACZ;;AAGF;IACE,aAAa;IACb,yDAAmD;IACnD,0DAAoD;IACpD,sBAAiB;IACjB,yCAAyC;EAC3C;;AAEA;IACE,sBAAsB;EACxB;;AAEA;IACE,yCAAyC;EAC3C;;AAEA;IACE,kDAAkD;EACpD;;AAEA;IACE,yDAAmD;IACnD,8DAAwD;EAC1D;;AAEA;IACE,iDAAiD;EACnD;;AAEA;IACE,6DAAuD;EACzD;;AAEA;IACE,2BAAwB;;IAExB,aAAa;IACb,gBAAgB;IAChB,oCAAoC;IACpC,uCAAuC;EACzC;;AAEA;IACE,sDAAgD;IAChD,yDAAmD;EACrD;;AArGF;;EAuGE,0DAA0D;AAmI5D;;AAlIE;IACE,aAAa;EACf;;AA1GF;;EA4GE,0DAA0D;AA8H5D;;AA7HE;IACE,aAAa;EACf;;AAEA;IACE,yBAAoB;EACtB;;AAEA;IACE,wBAAoB;EACtB;;AAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAe;IACf,cAAS;IACT,cAAU;EACZ;;AAEA;IACE,eAAe;IACf,kBAAkB;IAClB,YAAS;IACT,cAAW;EACb;;AAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,cAAW;EACb;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB;EAYF;;AAVE;MACE,mBAAgB;MAChB,oBAAiB;MACjB,oBAAiB;MACjB,mBAAe;MACf,sBAAsB;;MAEtB,sCAAsC;MACtC,4BAA4B;IAC9B;;AAIA;MACE,wDAAmD;MACnD,yDAAoD;MACpD,sBAAiB;MACjB;IAMF;;AAJE;QACE,qCAAiC;QACjC,8CAA8C;MAChD;;AAGF;MACE,8BAA8B;IAChC;;AAEA;MACE,8BAA8B;IAChC;;AAEA;MACE,8DAAwD;IAC1D;;AAEA;MACE,6DAAuD;IACzD;;AAEA;MACE,sDAAgD;MAChD,yDAAmD;IACrD;;AAGE;QACE,uBAAuB;MACzB;;AAIJ;IACE,WAAY;;IAEZ,0DAA0D;EAmB5D;;AAlBE;MACE,6BAA6B;MAC7B,sBAAsB;IACxB;;AAEA;MACE,uCAAuC;MACvC,wCAAwC;MACxC,uBAAiB;IACnB;;AAEA;MACE,6BAA6B;IAC/B;;AAEA;MACE,YAAY;IACd;;AAGF;IACE,aAAa;IACb,eAAe;IACf;EAKF;;AAHE;MACE,UAAU;IACZ;;AAIJ;EACE,kBAAkB;EAClB,qBAAa;UAAb,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".labelContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.inputLabel {\n  display: block;\n  margin-bottom: 16px;\n  white-space: nowrap;\n}\n\n.prefix {\n  display: flex;\n  align-items: center;\n  padding: 0 var(--form-input-prefix-padding);\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 30px;\n  height: 100%;\n  background-color: var(--grey-200);\n  border-top-left-radius: var(--form-input-border-radius);\n  border-bottom-left-radius: var(--form-input-border-radius);\n}\n\n.inputWrapper {\n  width: 100%;\n\n  & .inputInnerWrapper {\n    position: relative;\n  }\n\n  & .input {\n    --horizontal-padding: 24px;\n    --height: 64px;\n\n    padding-left: var(--horizontal-padding);\n    padding-right: var(--horizontal-padding);\n    background-color: var(--white);\n    border: 1px solid var(--grey-200);\n    color: var(--midnight-purple);\n    caret-color: var(--midnight-purple);\n    box-sizing: border-box;\n    border-radius: var(--form-input-border-radius);\n    width: 100%;\n    height: var(--height);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 18px;\n    line-height: 24px;\n    appearance: none;\n    outline: none;\n\n    &.inputWithPrefix {\n      height: calc(var(--height) - 2px);\n      margin-top: 0;\n      border: none;\n      border-top-right-radius: var(--form-input-border-radius);\n      border-bottom-right-radius: var(--form-input-border-radius);\n      flex-grow: 1;\n      padding-left: var(--form-input-prefix-padding);\n\n      &:focus {\n        padding-left: var(--form-input-prefix-padding);\n      }\n    }\n  }\n\n  & .input[type=number] {\n    /* remove arrows in Firefox */\n    -moz-appearance: textfield;\n\n    /* remove arrows in Chrome, Safari, Edge, Opera */\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n      opacity: 1;\n    }\n  }\n\n  & .input:focus {\n    outline: none;\n    padding-left: calc(var(--horizontal-padding) - 1px);\n    padding-right: calc(var(--horizontal-padding) - 1px);\n    border-width: 2px;\n    border-color: var(--primary-border-color);\n  }\n\n  & .input::placeholder {\n    color: var(--grey-300);\n  }\n\n  & .input:hover {\n    border-color: var(--primary-border-color);\n  }\n\n  & .inputWithRightIcon {\n    padding-right: calc(var(--horizontal-padding) * 2);\n  }\n\n  & .inputWithRightIcon:focus {\n    padding-left: calc(var(--horizontal-padding) - 1px);\n    padding-right: calc(var(--horizontal-padding) * 2 - 1px);\n  }\n\n  & .inputWithLeftIcon {\n    padding-left: calc(var(--horizontal-padding) * 2);\n  }\n\n  & .inputWithLeftIcon:focus {\n    padding-left: calc(var(--horizontal-padding) * 2 - 1px);\n  }\n\n  & .textArea {\n    --vertical-padding: 20px;\n\n    height: 160px;\n    resize: vertical;\n    padding-top: var(--vertical-padding);\n    padding-bottom: var(--vertical-padding);\n  }\n\n  & .textArea:focus {\n    padding-top: calc(var(--vertical-padding) - 1px);\n    padding-bottom: calc(var(--vertical-padding) - 1px);\n  }\n\n  /* stylelint-disable-next-line no-descending-specificity */\n  & .textArea::-webkit-resizer {\n    display: none;\n  }\n\n  /* stylelint-disable-next-line no-descending-specificity */\n  & .textArea::-webkit-scrollbar {\n    display: none;\n  }\n\n  & .textAreaWithMaxLength {\n    padding-bottom: 35px;\n  }\n\n  & .textAreaWithMaxLength:focus {\n    padding-bottom: 34px;\n  }\n\n  & .startAdornment {\n    cursor: pointer;\n    position: absolute;\n    font-size: 18px;\n    top: 21px;\n    left: 22px;\n  }\n\n  & .endAdornment {\n    cursor: pointer;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n  }\n\n  & .amountOfCharactersAllowed {\n    color: var(--grey-300);\n    position: absolute;\n    bottom: 16px;\n    right: 20px;\n  }\n\n  & .messageWrapper {\n    display: flex;\n    align-items: center;\n    padding-top: 12px;\n\n    & .message {\n      margin-left: 8px;\n      margin-right: 8px;\n      line-height: 20px;\n      font-size: 14px;\n      color: var(--grey-400);\n\n      /* 8 + 8 + 16 (margins and the icon) */\n      max-width: calc(100% - 32px);\n    }\n  }\n\n  &.error {\n    & .input {\n      padding-left: calc(var(--horizontal-padding) - 2px);\n      padding-right: calc(var(--horizontal-padding) - 2px);\n      border-width: 2px;\n      border-color: var(--error-red);\n\n      &.inputWithPrefix {\n        height: calc(var(--height) - 4px);\n        padding-left: var(--form-input-prefix-padding);\n      }\n    }\n\n    & .input:focus {\n      border-color: var(--error-red);\n    }\n\n    & .input:hover {\n      border-color: var(--error-red);\n    }\n\n    & .inputWithRightIcon {\n      padding-right: calc(var(--horizontal-padding) * 2 - 1px);\n    }\n\n    & .inputWithLeftIcon {\n      padding-left: calc(var(--horizontal-padding) * 2 - 1px);\n    }\n\n    & .textArea {\n      padding-top: calc(var(--vertical-padding) - 1px);\n      padding-bottom: calc(var(--vertical-padding) - 1px);\n    }\n\n    & .messageWrapper {\n      & .message {\n        color: var(--error-red);\n      }\n    }\n  }\n\n  &.disabled {\n    opacity: 0.5;\n\n    /* stylelint-disable-next-line no-descending-specificity */\n    & .input {\n      border-color: var(--grey-200);\n      color: var(--grey-300);\n    }\n\n    & .input:focus {\n      padding-left: var(--horizontal-padding);\n      padding-right: var(--horizontal-padding);\n      border-width: 1px;\n    }\n\n    & .input:hover {\n      border-color: var(--grey-200);\n    }\n\n    & .textArea {\n      resize: none;\n    }\n  }\n\n  & .inputInnerWrapperWithPrefix {\n    display: flex;\n    padding-left: 0;\n    padding-right: 0;\n\n    &.input {\n      padding: 0;\n    }\n  }\n}\n\n.noWrap {\n  white-space: unset;\n  hyphens: auto;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelContainer": `_5saOGoqaqZpkYn_5icC`,
	"inputLabel": `IEI8LVBd8zqINweD1LQr`,
	"prefix": `wY7RpKmRU7PpyQR1b7lK`,
	"inputWrapper": `DIa94qkaUorojjxBoaW8`,
	"inputInnerWrapper": `itFBSr501CJ1K6xENHIX`,
	"input": `VuK4CecepGSeSwTkC1CQ`,
	"inputWithPrefix": `xLrQziaN3K5nCv1XHpGg`,
	"inputWithRightIcon": `ma2xUY1yfXNY3BL2LDYZ`,
	"inputWithLeftIcon": `htmpsd5qxrh9LvOwBvFw`,
	"textArea": `B8rsTK4RqGn1suRBwybA`,
	"textAreaWithMaxLength": `_M5zfzDlwNx3sjNdOI9v`,
	"startAdornment": `vaeZOGUjbIQLFfX4JDFg`,
	"endAdornment": `NXATkVeiojKovBcZqxFV`,
	"amountOfCharactersAllowed": `DcO1wOEewzseWVtETbh0`,
	"messageWrapper": `AxEvxUN6MOLX9F7Z_cUp`,
	"message": `hsWV54zL5Y7qSYDYnQyn`,
	"error": `Z9HVzWhzLwR46SEgCaSZ`,
	"disabled": `bxaPPasZ_E4iBMbNH6vL`,
	"inputInnerWrapperWithPrefix": `l8o3DL_utNNkXx7ZEOD1`,
	"noWrap": `wEpvn100M9655bRc088q`
};
export default ___CSS_LOADER_EXPORT___;
